import _ from 'lodash';
import { getState, dispatch } from '@/store';
import { findModuleFromState } from '@/utils/utils';

const handlePlan = ({
  plan,
  formValues
}) => {
  var _chooseEnumBtnUnit$in, _chooseEnumBtnUnit$in2, _chooseEnumBtnType$in, _chooseEnumBtnType$in2, _newPlanList$planConf, _newPlanList$planConf2, _newPlanList$planConf3, _newPlanList$planConf4, _newPlanList$planConf5, _newPlanList$planConf6;

  if (!plan) {
    return;
  }

  const {
    insurancePlanTrialCollect,
    insurancePlanTrialCollectValue = {
      insurancePeriod: '',
      paymentPeriod: '',
      product: {},
      liability: {}
    },
    insurancePlanTrialCollectId = {
      insurancePeriodId: '',
      paymentPeriodId: ''
    },
    chooseEnumBtnUnit,
    chooseEnumBtnType
  } = formValues;
  const product = (insurancePlanTrialCollect === null || insurancePlanTrialCollect === void 0 ? void 0 : insurancePlanTrialCollect.product) || {};
  const liability = (insurancePlanTrialCollect === null || insurancePlanTrialCollect === void 0 ? void 0 : insurancePlanTrialCollect.liability) || {};
  const {
    insurancePeriod,
    paymentPeriod
  } = insurancePlanTrialCollectValue; //  用户选择的value存放

  const {
    insurancePeriodId,
    paymentPeriodId
  } = insurancePlanTrialCollectId;
  const sumProduct = insurancePlanTrialCollectValue.product;
  const selectedProductList = insurancePlanTrialCollectValue.product;
  const sumLiability = insurancePlanTrialCollectValue.liability;
  const selectedLiabilityList = insurancePlanTrialCollectValue.liability;
  const unitProduct = chooseEnumBtnUnit === null || chooseEnumBtnUnit === void 0 ? void 0 : (_chooseEnumBtnUnit$in = chooseEnumBtnUnit.insurancePlanTrialCollectValue) === null || _chooseEnumBtnUnit$in === void 0 ? void 0 : _chooseEnumBtnUnit$in.product;
  const unitLiability = chooseEnumBtnUnit === null || chooseEnumBtnUnit === void 0 ? void 0 : (_chooseEnumBtnUnit$in2 = chooseEnumBtnUnit.insurancePlanTrialCollectValue) === null || _chooseEnumBtnUnit$in2 === void 0 ? void 0 : _chooseEnumBtnUnit$in2.liability;
  const productCalcType = chooseEnumBtnType === null || chooseEnumBtnType === void 0 ? void 0 : (_chooseEnumBtnType$in = chooseEnumBtnType.insurancePlanTrialCollectValue) === null || _chooseEnumBtnType$in === void 0 ? void 0 : _chooseEnumBtnType$in.product;
  const liabilityCalcType = chooseEnumBtnType === null || chooseEnumBtnType === void 0 ? void 0 : (_chooseEnumBtnType$in2 = chooseEnumBtnType.insurancePlanTrialCollectValue) === null || _chooseEnumBtnType$in2 === void 0 ? void 0 : _chooseEnumBtnType$in2.liability;
  let productId;
  let liabilityId;

  const newPlanList = _.cloneDeep(plan); // //处理保障期间和缴费期间
  // newPlanList?.planConfigPackageList?.map((item)=>{ // 保障期间或者缴费期间找到对应的id 产品层级
  //   item?.planConfigProductList?.map((planItem,index)=>{
  //     if (planItem.id === Number(insurancePeriodId)){
  //       let insurancePeriodObj = insurancePeriod && JSON.parse(insurancePeriod)
  //        planItem.insurancePeriod = insurancePeriodObj?.value// 保障期间值
  //        planItem.insurancePeriodUnitType = insurancePeriodObj?.unitType// 保障期间单位
  //     }
  //     if (planItem.id === Number(paymentPeriodId)){
  //       let paymentPeriodObj = paymentPeriod && JSON.parse(paymentPeriod)
  //        planItem.paymentPeriod=paymentPeriodObj?.value// 缴费期间值
  //        planItem.paymentPeriodUnitType=paymentPeriodObj?.unitType// 缴费期间
  //     }
  //   })
  // })
  // 处理固定计划的保额


  newPlanList === null || newPlanList === void 0 ? void 0 : (_newPlanList$planConf = newPlanList.planConfigPackageList) === null || _newPlanList$planConf === void 0 ? void 0 : _newPlanList$planConf.forEach(packageItem => {
    var _packageItem$planConf;

    packageItem === null || packageItem === void 0 ? void 0 : (_packageItem$planConf = packageItem.planConfigProductList) === null || _packageItem$planConf === void 0 ? void 0 : _packageItem$planConf.forEach((productItem, index) => {
      // 保额算保费
      if (productItem.premiumCalculateType === 'bySumInsured') {
        var _productItem$planConf;

        // 产品层
        if (productItem.fixedSumInsuredValue) {
          if (productItem.sumInsuredType === 'fixed') {
            var _productItem$fixedSum;

            productItem.sumInsured = productItem === null || productItem === void 0 ? void 0 : (_productItem$fixedSum = productItem.fixedSumInsuredValue) === null || _productItem$fixedSum === void 0 ? void 0 : _productItem$fixedSum.value;
          }
        } // 责任层


        (_productItem$planConf = productItem.planConfigLiabilityList) === null || _productItem$planConf === void 0 ? void 0 : _productItem$planConf.forEach(liabilityItem => {
          if (liabilityItem.sumInsuredType === 'fixed') {
            var _liabilityItem$fixedS;

            liabilityItem.sumInsured = liabilityItem === null || liabilityItem === void 0 ? void 0 : (_liabilityItem$fixedS = liabilityItem.fixedSumInsuredValue) === null || _liabilityItem$fixedS === void 0 ? void 0 : _liabilityItem$fixedS.value;
          }
        });
      }
    });
  }); // 处理保障期间和缴费期间

  newPlanList === null || newPlanList === void 0 ? void 0 : (_newPlanList$planConf2 = newPlanList.planConfigPackageList) === null || _newPlanList$planConf2 === void 0 ? void 0 : _newPlanList$planConf2.forEach(item => {
    var _item$planConfigProdu;

    // 保障期间或者缴费期间找到对应的code 产品层级
    item === null || item === void 0 ? void 0 : (_item$planConfigProdu = item.planConfigProductList) === null || _item$planConfigProdu === void 0 ? void 0 : _item$planConfigProdu.forEach((planItem, index) => {
      if (selectedProductList) {
        Object.keys(selectedProductList).forEach(productCode => {
          if (planItem.productCode === productCode.slice(1)) {
            const insurancePeriodObj = selectedProductList[productCode].insurancePeriod && JSON.parse(selectedProductList[productCode].insurancePeriod);
            planItem.insurancePeriod = insurancePeriodObj === null || insurancePeriodObj === void 0 ? void 0 : insurancePeriodObj.value; // 保障期间值

            planItem.insurancePeriodUnitType = insurancePeriodObj === null || insurancePeriodObj === void 0 ? void 0 : insurancePeriodObj.unitType; // 保障期间单位

            const paymentPeriodObj = selectedProductList[productCode].paymentPeriod && JSON.parse(selectedProductList[productCode].paymentPeriod);
            planItem.paymentPeriod = paymentPeriodObj === null || paymentPeriodObj === void 0 ? void 0 : paymentPeriodObj.value; // 缴费期间值

            planItem.paymentPeriodUnitType = paymentPeriodObj === null || paymentPeriodObj === void 0 ? void 0 : paymentPeriodObj.unitType; // 缴费期间
          }
        });
      }
    });
  }); // 处理保额
  // newPlanList?.planConfigPackageList?.map((item) => {
  //   if (sumProduct) {// 产品层级
  //     for (let itemCode of Object.keys(sumProduct)) {
  //       let sumProductId = itemCode.slice(1)
  //       item?.planConfigProductList?.map((planItem, index) => {
  //         if (sumProductId === planItem.productCode) {
  //           let value = sumProduct[itemCode]
  //           let unit = unitProduct[itemCode]
  //           // if (unit === 'wanYuan'){
  //           //   planItem.sumInsured = Number(value*10000)
  //           // } else {
  //           //   planItem.sumInsured = Number(value)
  //           // }
  //           planItem.sumInsured = Number(value)
  //         }
  //         if (planItem.sumInsuredType === 'fixed') {
  //           planItem.sumInsured = planItem.fixedSumInsuredValue.value
  //         }
  //       })
  //     }
  //   }
  //   if (sumLiability) {// 责任层级
  //     for (let itemCode of Object.keys(sumLiability)) {
  //       let sumLiabilityId = itemCode.slice(1)
  //       item?.planConfigProductList?.map((planItem, index) => {
  //         planItem.planConfigLiabilityList.map((ele) => {
  //           if ((sumLiabilityId) === ele.liabilityCode) {
  //             let value = sumLiability[itemCode]
  //             // let unit = unitLiability[itemCode]
  //             // if (unit === 'wanYuan'){
  //             //   ele.sumInsured = Number(value*10000)
  //             // } else {
  //             //   ele.sumInsured = Number(value)
  //             // }
  //             ele.sumInsured = Number(value)
  //           }
  //           if (ele.sumInsuredType === 'fixed') {
  //             ele.sumInsured = ele.fixedSumInsuredValue.value
  //           }
  //         })
  //       })
  //     }
  //   }
  // })
  // 处理保额/保费

  newPlanList === null || newPlanList === void 0 ? void 0 : (_newPlanList$planConf3 = newPlanList.planConfigPackageList) === null || _newPlanList$planConf3 === void 0 ? void 0 : _newPlanList$planConf3.forEach(item => {
    if (selectedProductList) {
      // 产品层级
      Object.keys(selectedProductList).forEach(productCode => {
        var _item$planConfigProdu2;

        const currentProductCode = productCode.slice(1);
        item === null || item === void 0 ? void 0 : (_item$planConfigProdu2 = item.planConfigProductList) === null || _item$planConfigProdu2 === void 0 ? void 0 : _item$planConfigProdu2.forEach((planItem, index) => {
          if (currentProductCode === planItem.productCode) {
            var _selectedProductList$, _selectedProductList$2;

            // 处理因子
            const factorsObject = (_selectedProductList$ = selectedProductList[productCode]) === null || _selectedProductList$ === void 0 ? void 0 : _selectedProductList$.factors;

            if (!planItem.extraInfo) {
              planItem.extraInfo = {};
            }

            if (!planItem.dynamicFactorMap) {
              planItem.dynamicFactorMap = {};
            } // 合并对象不能改变对象的引用


            Object.keys(factorsObject || {}).forEach(_key => {
              planItem.dynamicFactorMap[_key] = factorsObject[_key];
              planItem.extraInfo[_key] = factorsObject[_key];
            });
            const value = (_selectedProductList$2 = selectedProductList[productCode]) === null || _selectedProductList$2 === void 0 ? void 0 : _selectedProductList$2.enum; // let calcType = productCalcType && productCalcType[productCode]?.enum;

            const calcType = planItem.premiumCalculateType; // 保费计算类型

            if (calcType === 'bySumInsured') {
              if (planItem.sumInsuredType === 'fixed') {
                planItem.sumInsured = planItem.fixedSumInsuredValue.value;
                return;
              }

              planItem.sumInsured = Number(value);
            } else {
              if (planItem.premiumType === 'fixed') {
                planItem.sumInsured = planItem.fixedPremiumValue.value;
                return;
              }

              planItem.premium = Number(value);
            }
          }
        });
      });
    }

    if (selectedLiabilityList) {
      // 责任层级
      Object.keys(selectedLiabilityList).forEach(liabilityCode => {
        var _item$planConfigProdu3;

        const currLiabilityCode = liabilityCode.slice(1);
        item === null || item === void 0 ? void 0 : (_item$planConfigProdu3 = item.planConfigProductList) === null || _item$planConfigProdu3 === void 0 ? void 0 : _item$planConfigProdu3.forEach((planItem, index) => {
          planItem.planConfigLiabilityList.forEach(ele => {
            if (currLiabilityCode === ele.liabilityCode) {
              var _selectedLiabilityLis;

              // 处理因子
              const factorsObject = (_selectedLiabilityLis = selectedLiabilityList[liabilityCode]) === null || _selectedLiabilityLis === void 0 ? void 0 : _selectedLiabilityLis.factors;

              if (!ele.extraInfo) {
                ele.extraInfo = {};
              }

              if (!ele.dynamicFactorMap) {
                ele.dynamicFactorMap = {};
              } // 合并对象不能改变对象的引用


              Object.keys(factorsObject || {}).forEach(_key => {
                ele.dynamicFactorMap[_key] = factorsObject[_key];
                ele.extraInfo[_key] = factorsObject[_key];
              });
              const value = selectedLiabilityList[liabilityCode].enum;
              const calcType = liabilityCalcType[liabilityCode].enum;

              if (calcType === 'bySumInsured') {
                if (ele.sumInsuredType === 'fixed') {
                  ele.sumInsured = ele.fixedSumInsuredValue.value;
                  return;
                }

                ele.sumInsured = Number(value);
              } else {
                if (ele.premiumType === 'fixed') {
                  ele.sumInsured = ele.fixedPremiumValue.value;
                  return;
                }

                ele.premium = Number(value);
              }
            }
          });
        });
      });
    }
  }); // 处理投保不投保 包含投保人豁免

  newPlanList === null || newPlanList === void 0 ? void 0 : (_newPlanList$planConf4 = newPlanList.planConfigPackageList) === null || _newPlanList$planConf4 === void 0 ? void 0 : _newPlanList$planConf4.forEach(item => {
    if (product) {
      Object.keys(product).forEach(itemCode => {
        var _item$planConfigProdu4;

        // 先遍历产品产品层级
        item === null || item === void 0 ? void 0 : (_item$planConfigProdu4 = item.planConfigProductList) === null || _item$planConfigProdu4 === void 0 ? void 0 : _item$planConfigProdu4.forEach((planItem, index) => {
          productId = itemCode.slice(1);

          if (productId === planItem.productCode) {
            // 产品层级
            if (product[itemCode] === 'N') {
              // 选择不投保 产品plan里面这个产品
              item.planConfigProductList.splice(index, 1);
            }
          }
        });
      });
    }

    if (liability) {
      var _item$planConfigProdu5;

      console.log('liability', liability); // 没有产品层级

      item === null || item === void 0 ? void 0 : (_item$planConfigProdu5 = item.planConfigProductList) === null || _item$planConfigProdu5 === void 0 ? void 0 : _item$planConfigProdu5.forEach((planItem, index) => {
        Object.keys(liability).forEach(itemCode => {
          var _planItem$planConfigL;

          // 再遍历责任层级 责任层级不投保，删除plan这个责任层级
          (planItem === null || planItem === void 0 ? void 0 : (_planItem$planConfigL = planItem.planConfigLiabilityList) === null || _planItem$planConfigL === void 0 ? void 0 : _planItem$planConfigL.length) > 0 && (planItem === null || planItem === void 0 ? void 0 : planItem.planConfigLiabilityList.forEach((liabilityItem, i) => {
            liabilityId = itemCode.slice(1);

            if (liabilityId === liabilityItem.liabilityCode) {
              if (liability[itemCode] === 'N') {
                planItem === null || planItem === void 0 ? void 0 : planItem.planConfigLiabilityList.splice(i, 1);
              } else if (liability[itemCode] === 'Y') {
                liabilityItem.optional = 'Y';
                delete liabilityItem.compensationWay;
              } else if (liability[itemCode] === 'amount' || liability[itemCode] === 'premium') {
                liabilityItem.compensationWay = liability[itemCode];
              }
            }
          }));
        });
      });
    }
  }); // 不管产品层级是必选还是可选 只要责任层级没有任何投保的 则删除这个产品层级

  newPlanList === null || newPlanList === void 0 ? void 0 : (_newPlanList$planConf5 = newPlanList.planConfigPackageList) === null || _newPlanList$planConf5 === void 0 ? void 0 : _newPlanList$planConf5.forEach(_product => {
    _product.planConfigProductList = _product.planConfigProductList.flatMap((item, index) => {
      if (item.planConfigLiabilityList.length === 0) {
        return []; // item.planConfigProductList?.splice(index, 1);
      }

      return [item];
    });
  });
  newPlanList === null || newPlanList === void 0 ? void 0 : (_newPlanList$planConf6 = newPlanList.planConfigPackageList) === null || _newPlanList$planConf6 === void 0 ? void 0 : _newPlanList$planConf6.forEach(_product => {
    _product.productList = _product.planConfigProductList;
    delete _product.planConfigProductList;

    _product.productList.forEach(item => {
      item.liabilityList = item.planConfigLiabilityList;
      delete item.planConfigLiabilityList;
    });
  }); // dispatch({
  //   handlePlan: newPlanList,
  // });

  return newPlanList;
};

export default handlePlan;